import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2597b913"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "story-card"
};
const _hoisted_2 = {
  class: "story-card-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success-story"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "客户之声"), /*#__PURE__*/_createElementVNode("p", {
  class: "title-description"
}, " 从基础服务做起、成为最懂出海企业需求的管家 ")], -1));
const _hoisted_4 = {
  class: "oversea-advertise"
};
const _hoisted_5 = {
  class: "oversea-advertise-img"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  class: "oversea-advertise-con"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "brief"
};
const _hoisted_10 = {
  class: "paragraph"
};
const _hoisted_11 = {
  class: "imgs-banner"
};
const _hoisted_12 = {
  class: "img-list"
};
const _hoisted_13 = ["onClick", "onMouseover"];
const _hoisted_14 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$storyList$_ctx$c, _ctx$storyList$_ctx$c2, _ctx$storyList$_ctx$c3, _ctx$storyList$_ctx$c4, _ctx$storyList$_ctx$c5;
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: (_ctx$storyList$_ctx$c = _ctx.storyList[_ctx.currIdx]) === null || _ctx$storyList$_ctx$c === void 0 ? void 0 : _ctx$storyList$_ctx$c.img_url,
    alt: (_ctx$storyList$_ctx$c2 = _ctx.storyList[_ctx.currIdx]) === null || _ctx$storyList$_ctx$c2 === void 0 ? void 0 : _ctx$storyList$_ctx$c2.name
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("h2", _hoisted_8, _toDisplayString((_ctx$storyList$_ctx$c3 = _ctx.storyList[_ctx.currIdx]) === null || _ctx$storyList$_ctx$c3 === void 0 ? void 0 : _ctx$storyList$_ctx$c3.name), 1), _createElementVNode("p", _hoisted_9, _toDisplayString((_ctx$storyList$_ctx$c4 = _ctx.storyList[_ctx.currIdx]) === null || _ctx$storyList$_ctx$c4 === void 0 ? void 0 : _ctx$storyList$_ctx$c4.brief), 1), _createElementVNode("p", _hoisted_10, _toDisplayString((_ctx$storyList$_ctx$c5 = _ctx.storyList[_ctx.currIdx]) === null || _ctx$storyList$_ctx$c5 === void 0 ? void 0 : _ctx$storyList$_ctx$c5.content), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("i", {
    class: "t-icon t-icon-arrow left",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.lookPrevImg && _ctx.lookPrevImg(...args))
  }), _createElementVNode("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: `${item}`,
      class: _normalizeClass(['img-item', _ctx.currIdx === index && 'is-larger']),
      onClick: $event => _ctx.handleClick(index),
      onMouseover: $event => _ctx.handleClick(index)
    }, [_createElementVNode("img", {
      src: item.imgsmall_url,
      alt: item.title
    }, null, 8, _hoisted_14)], 42, _hoisted_13);
  }), 128))]), _createElementVNode("i", {
    class: "t-icon t-icon-arrow",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.lookNextImg && _ctx.lookNextImg(...args))
  })])])])]);
}